import type { FaireProductEntity } from "../../entity_types/product";

export const p_cwgc9k27b2: FaireProductEntity = {
  token: "p_cwgc9k27b2",
  type: "product",
  name: "Embroidered Color Block Girlfriend Socks (Wholesale)",
  brandToken: "b_85a3118wke",
  brandName: "Le Bon Shoppe",
  imageUrl:
    "https://cdn.faire.com/fastly/753c76ceb7de1e3505bc6abea486362bf558a3f99300805c9e2d61674baeb444.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0182d11b882bdc307b0b4aba1b164a02e268d77c097350b7172268ff8c34db2c.jpeg",
    "https://cdn.faire.com/fastly/95783f97c8cf23afb4ab43ab54992ee476b5c36057a92c8a511f2044efbf0f35.jpeg",
    "https://cdn.faire.com/fastly/425ae3b3f66e50d6182d00dbdd21bc8544832a6d020f2117cff3c0db7f091351.jpeg",
    "https://cdn.faire.com/fastly/1c379fbf71ecf7a36fc84963acba7f03b1e7b8b879e8926e99620b630a6b1c60.jpeg",
    "https://cdn.faire.com/fastly/f3c1d7062bff46128803814d5aad4049e6252de7797bf320e40e8a8cb7c46368.jpeg",
    "https://cdn.faire.com/fastly/c5cfd01141383db436dc718ab66a14fb711bf1ad93192d92a322fc8510ebccb9.jpeg",
    "https://cdn.faire.com/fastly/3569a8a8bc2c86e2c6c37bdd9fa9019e07bb0b95aa63f004dd87e981aa1701e9.jpeg",
    "https://cdn.faire.com/fastly/a5bdd283919ef6565371629a863182d79e160e688c52a9e748790076f437d32d.jpeg",
  ],
  priceDollars: 7,
  description:
    "𝐖𝐡𝐲 𝐖𝐞 𝐌𝐚𝐝𝐞 𝐓𝐡𝐢𝐬?\n\nA playful take on our best-selling Girlfriend Socks. Designed with a color-blocked ankle, contrast toe and heel, and a charming embroidered motif at the ankle for a sweet touch. Easy to style with sandals or sneakers for everyday wear.\n\nMade in South Korea\n\n𝐂𝐨𝐧𝐭𝐞𝐧𝐭𝐬:\n\n85 Cotton 13 Polyester 2 Spdx\n\n𝐒𝐢𝐳𝐢𝐧𝐠:\n\nOne size fits most (US women's size 6-10)\n\n𝐂𝐚𝐫𝐞 𝐈𝐧𝐬𝐭𝐫𝐮𝐜𝐭𝐢𝐨𝐧𝐬:\n\n• Machine wash cold\n• Tumble dry low\n• Do not iron\n• Do not bleach\n\n***Order in units of 6 (6,12,18,24 etc)\n\n𝐌𝐒𝐑𝐏: $16 USD",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-21T21:51:53.107Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
